import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ageWarningBadge from "@/assets/age-warning.svg";

// P0 Performance: Desktop uses image, mobile uses CSS gradient for instant LCP
const heroBgDesktop = "/images/hero-bg-cannabis.webp";

export const Hero = () => {
  return (
    <section className="relative min-h-[85svh] md:min-h-[90vh] flex flex-col">
      {/* Background: CSS gradient on mobile, image on desktop */}
      <div className="absolute inset-0">
        {/* Mobile: pure CSS gradient - no image load, instant LCP */}
        <div className="md:hidden absolute inset-0 bg-gradient-to-br from-[#0A1F12] via-[#122a18] to-[#0d2614]" />
        
        {/* Desktop: image background */}
        <picture className="hidden md:block">
          <img 
            src={heroBgDesktop}
            alt=""
            aria-hidden="true"
            className="w-full h-full object-cover"
            loading="eager"
            decoding="async"
            fetchPriority="high"
            width={1920}
            height={1080}
            sizes="100vw"
          />
        </picture>
        {/* Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>
      
      {/* Main content - centered overlay */}
      <div className="flex-1 flex items-center justify-center relative z-10">
        <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-3xl mx-auto text-center">
            
            {/* Main headline */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-6 text-white drop-shadow-lg">
              THCA Sverige
              <br />
              <span className="bg-gradient-to-r from-primary via-gold to-primary bg-clip-text text-transparent drop-shadow-none">
                Köp THCA Vape &amp; Magic Sauce Online
              </span>
            </h1>
            
            {/* Subheadline */}
            <p className="text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed drop-shadow">
              Sveriges ledande sortiment av labbtestade THCA vapes. 100 % lagligt.
            </p>

            {/* Primary CTA */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
              <Link
                to="/kollektioner/alla-produkter"
                className="inline-flex items-center justify-center gap-2 px-10 py-4 text-lg font-bold rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/30 transition-all duration-200 min-w-[200px]"
              >
                Handla Nu
                <ArrowRight className="w-5 h-5" />
              </Link>
              <Link
                to="/kollektioner/thca-vapes"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 text-sm font-semibold rounded-lg border border-white/30 text-white hover:bg-white/10 transition-all duration-200"
              >
                Se THCA Vapes
              </Link>
            </div>

            {/* Micro trust indicators */}
            <p className="text-xs md:text-sm text-white/60 mb-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
              <span>18+</span>
              <span className="hidden sm:inline">|</span>
              <span>Svensk leverans</span>
              <span className="hidden sm:inline">|</span>
              <span>Labbtestat</span>
            </p>
            
            {/* 18+ Badge */}
            <div className="flex justify-center">
              <img
                src={ageWarningBadge}
                alt="18+ åldersgräns – THCA vape Sverige"
                className="w-14 h-14 md:w-16 md:h-16"
                title="Denna produkt säljs endast till personer över 18 år"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
